import { useRouter } from 'next/router';
import React, { useState, useRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import { RAF } from '../../brands/default/features';
import {
  LINK_LOGIN,
  LOGIN_MENU,
  RAF_ENABLED_LOGIN_MENU,
} from '../../brands/default/links';
import { redirectToURL } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import WowModal from '../WowModal';
import HeaderIcon from './HeaderIcon';
import { HeaderLogout } from './HeaderLogout';

const HeaderLogin = () => {
  const router = useRouter();
  const theme = useContext(ThemeContext);

  const userState = useSelector((state) => state.user.isAuthenticated);
  const ariaHasPopup = userState || null;
  const [showModal, setShowModal] = useState(false);
  const ariaExpanded = userState ? showModal : null;
  const ref = useRef(null);

  // RAF Enabled mobile menu controlled by the env variable (wowcher only)

  const rafEnabled = RAF;

  const onClickIcon = (show) => {
    if (!userState) {
      redirectToURL(LINK_LOGIN, router);

      return;
    }
    setShowModal(show);
  };

  const listItems = () => {
    const list = rafEnabled ? RAF_ENABLED_LOGIN_MENU : LOGIN_MENU;
    if (!list) return null;

    return list.map((item, index) => {
      return (
        <li
          className="account__menu-item"
          key={`headerlogin-account__menu-item-${index}`}
          onClick={() => redirectToURL(item.href, router)}
          onKeyPress={() => redirectToURL(item.href, router)}
          role="menuitem"
        >
          {item.text}
        </li>
      );
    });
  };

  return (
    <>
      <div ref={ref} />

      <WowModal
        ariaLabelledBy="id-subscribe"
        backdropClassName="remove-backdrop"
        container={ref.current}
        extraClasses="remove-header headerlogin-menu header-icon--hidden-mobile"
        setShowModal={setShowModal}
        showModal={showModal}
        size="md"
        title=""
      >
        <div className="menulogin-container">
          <ul className="list" role="menu">
            {listItems()}
            <HeaderLogout
              extraClass="account__menu-item"
              setShowModal={setShowModal}
            />
          </ul>
        </div>
      </WowModal>

      <HeaderIcon
        ariaExpanded={ariaExpanded}
        ariaHasPopup={ariaHasPopup}
        clickMethod={() => onClickIcon(true)}
        icon="login"
        isLoggedIn={userState}
        isMobileHidden
      />
      <style jsx>{`
        .menulogin-container {
          position: relative;
        }
        ul.list {
          padding: 0;
          margin: 0;
          list-style: none;
          width: 100%;
        }
      `}</style>
      <style global jsx>{`
        li.account__menu-item {
          padding: 4px 5px 4px 10px;
          display: block;
          cursor: pointer;
          text-align: -webkit-match-parent;
        }
        li.account__menu-item:hover {
          background: ${theme.colors.primary};
          color: white;
        }
      `}</style>
    </>
  );
};

export default HeaderLogin;
